"use client";

import { trackSeoLoggedOutBrandC2TabClick } from "@faire/web-api/events/seo/click/loggedOutBrandC2Tab";
import { trackSeoLoggedOutBrandTabScroll } from "@faire/web-api/events/seo/scroll/loggedOutBrandTab";
import { IFilterOption } from "@faire/web-api/indigofair/data/IFilterOption";
import { getWindow } from "@faire/web/common/globals/getWindow";
import { MIN_WIDTH_BREAKPOINTS } from "@faire/web/common/media";
import { getWindowWidth } from "@faire/web/ui/hooks/useObservableWindow";
import { History } from "history";
import React from "react";

import { FilterTabsBase } from "./__internal__/FilterTabsBase";
import { useLoggedOutProductFilters } from "./brand-products/useLoggedOutProductFilters";

export const FilterTabs: React.FC<{
  brandToken: string | undefined;
  categoryFilterOptions: Array<IFilterOption> | null;
  scrollIntoViewOnClickMobileElementId?: string;
  locationPush: (location: History.LocationDescriptor) => void;
}> = ({
  brandToken,
  categoryFilterOptions,
  scrollIntoViewOnClickMobileElementId,
  locationPush,
}) => {
  const { activeTab, setCategoryFilterKey } =
    useLoggedOutProductFilters(locationPush);
  const handleFilterSelected = (categoryFilterKey: string) => {
    trackSeoLoggedOutBrandC2TabClick(brandToken ?? "", categoryFilterKey);
    setCategoryFilterKey(categoryFilterKey);
  };

  return (
    <FilterTabsBase
      categoryFilterOptions={categoryFilterOptions}
      activeTab={activeTab}
      onTabChange={(key) => {
        if (key === activeTab) {
          return;
        }

        handleFilterSelected(key);

        const isMobile = getWindowWidth() < MIN_WIDTH_BREAKPOINTS.TABLET;
        if (isMobile && scrollIntoViewOnClickMobileElementId) {
          getWindow()
            ?.document.getElementById(scrollIntoViewOnClickMobileElementId)
            ?.scrollIntoView();
        }
      }}
      onScroll={(start, end) => {
        trackSeoLoggedOutBrandTabScroll(
          brandToken ?? "",
          start.toString(),
          end.toString(),
          // Determines if the Tabs component has been scroll to its end
          // (with a threshold of 95%).
          end > 0.95 ? "true" : "false"
        );
      }}
    />
  );
};
